import { Chip } from '@global-engineering-shared/gweb-material-global';
import { GlobalAutocomplete } from '@global-engineering-shared/gweb-material-global';
import { Checkbox, TextField } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import useStyles from 'features/Filters/MultipleFilters/MultipleFilters.styles';
import { Filters } from 'features/Filters/types/Filters';

type MultipleFiltersProps = {
  label: string;
  options: string[];
  setSelectedFilters: React.Dispatch<React.SetStateAction<Filters>>;
  filterKey: string;
  filters: Filters;
};

const MultipleFilters = ({
  label,
  options,
  setSelectedFilters,
  filterKey,
  filters,
}: MultipleFiltersProps) => {
  const classes = useStyles();

  const onChange = (value: string[]) => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [filterKey as keyof Filters]: value,
    }));
  };

  const getDefaultValue = (): string[] => {
    return filters[filterKey as keyof Filters];
  };

  return (
    <GlobalAutocomplete<string, true, false, false>
      data-testid="multipleFilters"
      key={label}
      className={classes.filterBox}
      multiple
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            label={option}
            className={classes.filterChip}
            key={index}
          />
        ))
      }
      disableCloseOnSelect
      limitTags={2}
      renderInput={(params) => (
        <TextField {...params} className={classes.renderInput} label={label} />
      )}
      options={options}
      renderOption={(option, { selected }) => (
        <React.Fragment>
          <Checkbox checked={selected} />
          {option}
        </React.Fragment>
      )}
      onChange={(_event, value) => onChange(value as string[])}
      defaultValue={getDefaultValue()}
    />
  );
};

export default MultipleFilters;
